export default "\n<router-outlet></router-outlet>\n\n"